import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Constant from "../Constant";
import SelectAsync from 'react-select/async';

export default class Bulletin extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            readOnly: this.isNull(props.ReadOnly) ? false : props.ReadOnly,
            caller: props.Caller,
            data: null,
            loading: true,
            coverBase64: ''
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    setCoverPic(_file) {
        this.getBase64(_file).then(file => {
            this.state.coverBase64 = file;
        });
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/bulletin/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        e.preventDefault();

        this.httpPost("api/v1/bulletin/save", {
            id: this.getCurrentFormId(),
            companyId: this.state.data.global.company.id,
            title: this.state.data.record.title,
            content: this.state.data.record.content,
            categoryId: this.state.data.record.categoryId,
            userGroups: this.state.data.record.userGroups,
            coverBase64: this.state.coverBase64,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setGroup(e) {
        if (e.value == -1) {
            this.state.data.record.categoryId = this.defaultGuid();
            this.state.data.record.categoryName = '';
            this.showComponents({ component: <Constant Type={11} Caller={this} FromAutoComplete={true} /> });
            return;
        }
        this.state.data.record.categoryId = e.value;
        this.state.data.record.categoryName = e.label;
        this.setState({ data: this.state.data });
    }
    setUserGroups(e) {
        this.state.data.record.userGroups = e;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            {this.state.readOnly ? <h4 className="modal-title">
                                مشاهده خبر
                            </h4> :
                                <h4 className="modal-title">
                                    {this.state.data.record.id !== this.defaultGuid() ? "ویرایش محتوای خبر" : "افزودن خبر جدید"}
                                </h4>}
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-label">عنوان</label>
                                            {this.state.readOnly ? <div className="form-control-wrap">
                                                {this.state.data.record.title}
                                            </div>
                                                :
                                                <div className="form-control-wrap">
                                                    <input className="form-control" type="text" defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="form-group">
                                            <label className="form-label">گروه خبری</label>
                                            {this.state.readOnly ?
                                                <div className="form-control-wrap">
                                                    {this.state.data.record.categoryName}
                                                </div>
                                                :

                                                <div className="form-control-wrap">
                                                    <SelectAsync
                                                        value={this.state.data.record.categoryId != this.defaultGuid() ? [{ value: this.state.data.record.categoryId, label: this.state.data.record.categoryName }] : null}
                                                        isMulti={false}
                                                        placeholder="انتخاب گروه"
                                                        defaultOptions
                                                        loadOptions={(inputValue, callback) => this.loadConstantsOptions(inputValue, callback, 11, 1)}
                                                        onChange={e => this.setGroup(e)}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    {!this.state.readOnly && <div className="col-lg-3">
                                        <div className="form-group">
                                            <label className="form-label">فایل</label>
                                            <div className="form-control-wrap">
                                                <input type="file" onChange={(e) => { this.setCoverPic(e.target.files[0]) }} />
                                            </div>
                                        </div>
                                    </div>}
                                    {!this.isBlank(this.state.data.record.cover) && <div className="col-lg-3">
                                        <div className="form-group">
                                            {this.state.readOnly ? <label className="form-label">فایل پیوست</label>
                                                : <label className="form-label">فایل فعلی</label>}
                                            <div className="form-control-wrap">
                                                <a href={this.state.data.record.coverPath} target="_blank">مشاهده</a>
                                            </div>
                                        </div>
                                    </div>}
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-label">متن</label>
                                            {this.state.readOnly ? <div className="form-control-wrap">
                                                {this.state.data.record.content}
                                            </div>
                                                :
                                                <div className="form-control-wrap">
                                                    <textarea className="form-control" type="text" defaultValue={this.state.data.record.content} onChange={e => this.state.data.record.content = e.target.value} style={{ height: "300px" }}></textarea>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    {!this.state.readOnly && <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-label">گروه کاربران مشاهده کننده</label>
                                            <div className="form-control-wrap">
                                                <SelectAsync
                                                    defaultValue={this.state.data.record.userGroups}
                                                    isMulti={true}
                                                    placeholder="انتخاب گروه ها"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadUserGroupsOptions(inputValue, callback)}
                                                    onChange={e => this.setUserGroups(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>}
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            {!this.state.readOnly && <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}